/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useHistory} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login, loginnew} from '../redux/AuthCRUD'
import {toast} from 'react-toastify'
import {toAbsoluteUrl} from '../../../../_eLab/helpers'

const loginSchema = Yup.object().shape({
  username: Yup.string()
    // .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('UserName is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  username: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        // var objEmp3 = btoa(JSON.stringify(values))
        // loginnew(`${objEmp3}`)
        login(values.username, values.password, '', '')
          .then(({data}) => {
            // console.log(data)
            // if (data.roleID == 0) {
            //   toast.error('You have not right to login, Please contact to concerned person')
            //   setLoading(false)
            //   setSubmitting(false)
            //   setStatus('The login detail is incorrect1')
            //   return
            // }
            // var data2 = JSON.parse(atob(data.loginResp))

            // if (data2.isSuccess == true) {
            //   dispatch(auth.actions.login(data2))
            //   setLoading(false)
            //   setSubmitting(true)
            if (data.isSuccess == true) {
              // toast.error(`Testing mode RoleID:->${data.roleID}`)
              dispatch(auth.actions.login(data))
              setLoading(false)
              setSubmitting(true)
            } else {
              toast.error('The login detail is incorrect')
              setLoading(false)
              setSubmitting(false)
              setStatus('The login detail is incorrect')
            }
          })
          .catch((e) => {
            toast.error(`Error Occured...${e}`)
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect2')
          })
      }, 1000)
    },
  })

  return (
    <>
      {/* <div className='d-flex flex-column flex-column-fluid m-10 p-10 pb-lg-20 ms-8'> */}
      {/* <span className='mb-12 text-center'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/AGM_Logo.png')} className='h-30px' />
        </span> */}
      <h3 className=' text-center mb-7  '>Login</h3>
      <div className='form-container sign-in-container'>
        <form className='form' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form'>
          {/* User Icon at the top */}
          

          {/* begin::Form group */}
          <div className='fv-row mb-5'>
            {/* User Name Field with Icon */}
            <div className='input-group bg-solid'>
              <span className='input-group-text'>
                <i className='fa fa-user text-black-50 fa-1x'></i> {/* User Icon */}
              </span>
              <input
                placeholder='Username'
                {...formik.getFieldProps('username')}
                className={clsx('form-control form-control-lg form-control-solid', {
                  'is-invalid': formik.touched.username && formik.errors.username,
                  'is-valid': formik.touched.username && !formik.errors.username,
                })}
                type='text'
                name='username'
                autoComplete='off'
              />
            </div>

            {/* Validation Error Message */}
            {formik.touched.username && formik.errors.username && (
              <div className='fv-plugins-message-container text-danger'>
                <span role='alert'>{formik.errors.username}</span>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            {/* Password Field with Icon */}
            <div className='input-group'>
              <span className='input-group-text'>
                <i className='fa fa-key text-black-50 fa-1x'></i> {/* Password Icon */}
              </span>
              <input
                type='password'
                autoComplete='off'
                placeholder='Password'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
            </div>

            {/* Validation Error Message */}
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container text-danger'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Action */}
          <div className='text-center mt-3'>
            <button
              type='submit'
              id='kt_sign_in_submit'
              className='btn btn-lg btn-primary w-100 mb-5'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {!loading && <span className='indicator-label'>Continue</span>}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>

          {/* Forgot Password Link */}
          <div className='d-flex justify-content-start mt-3'>
            <div className='d-flex flex-stack mb-2'>
              <Link
                to='/auth/forgot-password'
                className='link-primary fs-6 fw-bolder'
                style={{marginLeft: '5px'}}
              >
                Forgot Password?
              </Link>
            </div>
          </div>
          {/* end::Action */}
        </form>
      </div>

      {/* </div> */}
    </>
  )
}
